export const platformVersion = '^21.0.1';
